import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyD5z7yj-qtB4dVTRWq9OGprim4Ss-q0sdA",
  authDomain: "kbx-tournament.firebaseapp.com",
  projectId: "kbx-tournament",
  storageBucket: "kbx-tournament.firebasestorage.app",
  messagingSenderId: "477252132421",
  appId: "1:477252132421:web:10c1c5c558d3c0d9aa0d2c"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);